import { useMemo } from 'react';

import moment from 'moment';

import column, { defaultActionsColumn, defaultColumn, defaultColumnId } from '@/components/Grid/utils/column';
import { formatters } from '@/components/hierarchical-report/utils';

import creditAction from './CreditAction';
import resetAction from './ResetAction';
import StatusFormatter from './StatusFormatter';
import transactionsAction from './TransactionsAction';

export default function useColumns() {
  return useMemo(() => [
    defaultColumnId(),
    defaultColumn('type', 'Bucket Type'),
    defaultColumn('subidKey', 'Description', info => info.getValue() || 'Default'),
    defaultColumn('currentBalance', 'Beta Current Balance', info => formatters.money()(info.getValue())),
    defaultColumn('redisValue', 'Legacy Current Balance', info => formatters.money()(info.getValue())),
    defaultColumn('threshold', 'Balance Threshold', info => formatters.money()(info.getValue())),
    column.accessor('freeBucket', {
      header: 'Status',
      cell: info => <StatusFormatter info={info} />,
    }),
    column.accessor('deadtime', {
      header: 'Time to Live',
      cell: info => moment.duration(moment().diff(moment(info.getValue()))).humanize(),
    }),
    defaultActionsColumn(creditAction, resetAction, transactionsAction),
  ], [])
}
